export { default } from './EnergiaSolarEconomia';
